import type { MagentoApiRemoveCouponsFromCartMutationResponse } from "@jti/magento-api-v2";
import { MagentoGraphQLRequestClientError } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const removeCouponsFromCartEndpoint = (builder: MagentoApiBuilder) => ({
  removeCouponsFromCart: builder.mutation<
    MagentoApiRemoveCouponsFromCartMutationResponse,
    { cartId: string; couponCodes: string[] }
  >({
    query: ({ cartId, couponCodes }) => ({
      method: "removeCouponsFromCart",
      params: [{ cartId, couponCodes }],
    }),
    transformErrorResponse: (error) => {
      if (!MagentoGraphQLRequestClientError.isMagentoGraphQLRequestClientError(error)) {
        if (error instanceof Error) {
          const errorsDetails = (error as any).response?.errors;
          const message = errorsDetails?.[0]?.message ?? error.message;
          return { message };
        }
        return error;
      }

      const errorsDetails = error.errorsDetails;
      const message = errorsDetails ? errorsDetails[0].message : error.message;

      return { message };
    },
    invalidatesTags: [TAGS.COUPONS, TAGS.CART_ITEMS, TAGS.CART_ORDER_PRICES, TAGS.AVAILABLE_PAYMENT_METHODS],
  }),
});
